// Resolves once the page has loaded and the browser is idle, so non-critical work never competes with first paint.
export default function whenIdle() {
    return new Promise((resolve) => {
        const idle = () => (window.requestIdleCallback ? window.requestIdleCallback(resolve, { timeout: 2000 }) : setTimeout(resolve, 300));
        if (document.readyState === "complete") idle();
        else window.addEventListener("load", idle, { once: true });
    });
}
